export function errorToString(error) {
	if(Array.isArray(error)) {
		return error.reduce((acc, err) => `${acc} ${err}`, '');
	} else {
		return error.toString();
	}
}

export function match(pattern, failMessage) {
	return (data, field, required, t) => ((!required && !data[field]) || (data[field] && data[field].match && !!data[field].match(pattern)) || failMessage);
}

export function nomatch(pattern, failMessage) {
	return (data, field, required, t) => ((!required && !data[field]) || (data[field] && data[field].match && !(!!data[field].match(pattern))) || failMessage);
}

export function all() {
	const conditions = [...arguments]; 
	return (data, field, required, t) => {
		const check = conditions.reduce((acc, cond) => {
			const r = cond(data, field, required, t);
			if(r !== true) acc.push(r);
			return acc;
		}, []);
		return check.length === 0 ? true : errorToString(check);
	}
}

export function fieldsMatch(field1, field2, failMessage) {
	return (data, _, required) => {
		const r =  (data[field1] === data[field2]) || failMessage;
		return r;
	}
}